export default __webpack_public_path__ + "static/media/parcel_hub_logo.b2336299.svg";